import { Keywords } from "../fields/recordm.fields";
import { getIndexFieldName } from "../helpers/recordm.value-formatter";

const AutoRefField = function(internal, args) {
    let _sourceFieldId, _instance, useStrictEquality;

    const getField = function(name) {
        let val
        if (_instance && _instance.data) {
            const field = useStrictEquality ? name : getIndexFieldName(name)
            val = _instance.data[field] || _instance.data[name]; // fallback to non-processed field name (fix for usernameAD)
        }

        return val;
    };

    return{
        init: function(_instance, {find, onChange}) {
            const target = find(args.source_field);
            _sourceFieldId = target.id;
            internal.subscribe('field-value-change-byDef-' + target.defId, onChange);

            if (target?.field?.fieldDefinition) {
                useStrictEquality = target.field.fieldDefinition.isA(Keywords.ExternalReference)
            }
        },
        setArgs: function(field, value) {
            if (_sourceFieldId === field) {
                _instance = value;
            }
        },
        apply: function(fallbackValue) {
            const updatedValue = getField(args.field_name)
            if(updatedValue){
                return {value: updatedValue};

            } else {
                return {
                   value: fallbackValue,
                   outdated: _instance !== undefined && _instance !== ''
                };
            }
        }
    }
};

export { AutoRefField };
